export default "__VITE_ASSET__Cvg4n4PF__"